// 暴露环境变量给全局作用域
export const MY_ENV_VARIABLE = process.env.VUE_APP_COLRO_PAGE;
